module.exports = __webpack_public_path__ + "static/media/Engpic5@2x.a5cf02c7.png";